import { reactive } from 'vue';

function getDirection(x, y) {
  if (x > y && x > DISTANCE) return 'horizontal';
  /* istanbul ignore next */
  if (x <= y && y > DISTANCE) return 'vertical';
  return null;
}
// 确定手势方向的最小距离
var DISTANCE = 5;
/**
 * 主要用于记录手势状态，目前只支持单指
 * @returns
 */
function useTouch() {
  var state = reactive({
    startTime: 0,
    // 起点
    startX: 0,
    startY: 0,
    // 距离变化量
    deltaX: 0,
    deltaY: 0,
    // 距离的绝对值
    offsetX: 0,
    offsetY: 0,
    // 在手势竞争中获胜的方向
    direction: ''
  });
  function reset() {
    state.startX = 0;
    state.startY = 0;
    state.deltaX = 0;
    state.deltaY = 0;
    state.offsetX = 0;
    state.offsetY = 0;
    state.direction = null;
  }
  function start(e) {
    reset();
    state.startTime = Date.now();
    state.startX = e.touches[0].clientX;
    state.startY = e.touches[0].clientY;
  }
  function move(e) {
    state.deltaX = e.touches[0].clientX - state.startX;
    state.deltaY = e.touches[0].clientY - state.startY;
    state.offsetX = Math.abs(state.deltaX);
    state.offsetY = Math.abs(state.deltaY);
    if (!state.direction) {
      state.direction = getDirection(state.offsetX, state.offsetY);
    }
  }
  return {
    state: state,
    start: start,
    move: move,
    reset: reset,
    speed: {
      get x() {
        return state.offsetX / (Date.now() - state.startTime);
      },
      get y() {
        return state.offsetY / (Date.now() - state.startTime);
      }
    }
  };
}

export { useTouch as default };
